// import {preRouterMap} from" @/router"
const types = {
  HANDLE_LEFT_MENU: 'HANDLE_LEFT_MENU', // 收缩左侧菜单
  // INIT_LEFT_MENU: 'INIT_LEFT_MENU', // 初始化左侧菜单
  SET_LEFT_COLLAPSE: 'SET_LEFT_COLLAPSE' ,// 改变左边菜单的收缩宽度
  SHOW_TASK_TEMPLATE_ASSESS: 'SHOW_TASK_TEMPLATE_ASSESS',
  SET_TEMPLATE_FORMS: 'SET_TEMPLATE_FORMS',
}
const menu = {
  state: {
    sidebar: {
      opened: true,
      width: 220
    },
    minLeftMenuWidth: 60,
    maxLeftMenuWidth: 220,
    collapsed: false, // 菜单默认展开
    isFooter: false,
    showTaskTemplateAssess: false,//是否显示任务模板绑定标准页面
    templateForms: {},//选中的任务模板数据
    expireCount:0
  },
  getters: {
    sidebar: state => state.sidebar,
    collapsed: state => state.collapsed,
    isFooter: state => state.isFooter,
    taskTemplateAssess: state =>{
      return {
        show: state.showTaskTemplateAssess,
        templateForms: state.templateForms
      }
    }
  },
  mutations: {
    [types.HANDLE_LEFT_MENU] (state) {
      if (state.sidebar.opened) { // true
        state.sidebar.width = state.minLeftMenuWidth
      } else {
        state.sidebar.width = state.maxLeftMenuWidth
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    // [types.INIT_LEFT_MENU] (state) {
    //   state.sidebar = state.sidebar
    // },
    [types.SET_LEFT_COLLAPSE] (state) {
      state.collapsed = !state.collapsed
    },
    [types.SHOW_TASK_TEMPLATE_ASSESS] (state,status) {
      state.showTaskTemplateAssess = status
    },
    [types.SET_TEMPLATE_FORMS] (state,status) {
      state.templateForms = status
    },
    SET_EXPIRE_COUNT(state,status) {
      //console.log(`state.expireCount = ${status}`)
      state.expireCount = status
    }
  },
  actions: {
    handleLeftMenu: ({ commit }) => {
      commit(types.HANDLE_LEFT_MENU)
    },
    // initLeftMenu: ({ commit }) => {
    //   commit(types.INIT_LEFT_MENU)
    // },
    setLeftCollapse: ({ commit }) => {
      commit(types.SET_LEFT_COLLAPSE)
    }
  }
}
export default menu
